import React, { useState, useEffect } from 'react';
import { Reel } from 'types/reelPlayer';
import classNames from 'classnames';

import styles from './ActiveReelBar.module.scss';

const ActiveReelBar = React.memo<{
  reel: Reel;
  isFullScreen: boolean;
}>(({ reel, isFullScreen }) => {
  const [currentReelProgress, setCurrentReelProgress] = useState(0);
  const [currentReelTime, setCurrentReelTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const videoElements = document?.querySelectorAll('video') || [];
      videoElements.forEach((video) => {
        if (
          !video.paused &&
          video.currentTime !== undefined &&
          reel.highlightUrl &&
          video.currentSrc.includes(reel.highlightUrl)
        ) {
          setCurrentReelTime(video.currentTime);
          setCurrentReelProgress(Math.min((video.currentTime / video.duration) * 100, 100));
        }
      });
    }, 100);

    return () => clearInterval(interval);
  }, [reel, currentReelTime]);

  return (
    <div className={styles.wrapper}>
      <div className={classNames(styles.bar, isFullScreen && styles.fullScreenBar)}>
        <div className={styles.barFill} style={{ width: `${currentReelProgress}%` }} />
      </div>
    </div>
  );
});

ActiveReelBar.displayName = 'ActiveReelBar';

export default ActiveReelBar;
